import { render, staticRenderFns } from "./_UserForm.vue?vue&type=template&id=023c248b&"
import script from "./_UserForm.vue?vue&type=script&lang=ts&"
export * from "./_UserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports